export const WITH_LOGOUT = "withLogout"
export const ROOMS_LENGTH_SKELETON = "@ROOMS_LENGTH_SKELETON"
export const ROOMS_POSITIONS_SKELETON = "@ROOMS_POSITIONS_SKELETON"
export const ROOMS_GRID_SKELETON = "@ROOMS_GRID_SKELETON"
export const ROOMS_SIZE_SKELETON = "@ROOMS_SIZE_SKELETON"
export const FIXED_ROOM_SIZE = "FIXED_ROOM_SIZE"
export const TABLES_LENGTH_SKELETON = "@TABLES_LENGTH_SKELETON"
export const TABLES_POSITIONS_SKELETON = "@TABLES_POSITIONS_SKELETON"
export const TABLES_DIMENSIONS_SKELETON = "@TABLES_DIMENSIONS_SKELETON"